

























import Vue from 'vue'
export default Vue.extend({
  name: 'ArticleCard',
  props: {
    imageUrl: {
      type: String,
      default: 'https://via.placeholder.com/308x172'
    },
    title: {
      type: String,
      default: 'Default title'
    },
    description: {
      type: String,
      default: 'Default multiline description. Hope this will go to to the second line.'
    },
    bookmarked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageStyle (): Record<string, string> {
      return {
        backgroundImage: `url("${this.imageUrl}")`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'transparent',
        borderRadius: '8px',
        width: '100%',
        height: '172px'
      }
    }
  },
  methods: {
    bookmarkPressed (event: KeyboardEvent) {
      if ([10, 13].some(code => code === event.keyCode)) {
        this.$emit('bookmarkClicked')
      }
    },
    bookmarkClicked () {
      (this.$refs.bookmarkButton as any).blur()
      this.$emit('bookmarkClicked')
    }
  }
})
